import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopMinDeliveryAmount from '@core/reducers/shop/selectors/getShopMinDeliveryAmount';
import getCartSubtotal from '@core/reducers/cart/selectors/getCartSubtotal';
import getCartTotal from '@core/reducers/cart/selectors/getCartTotal';
import getCartId from '@core/reducers/cart/selectors/getCartId';
import getCartItems from '@core/reducers/cart/selectors/getCartItems';

const EVENT_NAME = 'add_more_food.clicked';

const trackAddMoreFoodClicked = () => (_, getState) => {
  try {
    const state = getState();
    const shopId = getShopId(state);
    const cartGuid = getCartId(state);
    const cartValue = getCartTotal(state);
    const cartSubTotal = getCartSubtotal(state);
    const cartStatus = 'minOrderValue';
    const shopMinimumOrderValue = getShopMinDeliveryAmount(state);
    const cartQuantity = getCartItems(state).reduce(
      (a, b) => a + b.quantity,
      0,
    );

    const payload = {
      shopId,
      cartGuid,
      cartValue,
      cartSubTotal,
      cartStatus,
      shopMinimumOrderValue,
      cartQuantity,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackAddMoreFoodClicked;
